import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';

@Component({
    selector: 'exp-share-buttons',
    templateUrl: './exp-share-buttons.component.html',
    styleUrls: ['./exp-share-buttons.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ShareButtonsModule]
})
export class ExpShareButtonsComponent implements OnInit {

  @Input() url: string;
  @Input() title: string;
  @Input() image: string;
  @Input() description: string;
  @Input() show = 3;
  @Input() autoSetMeta = true;

  constructor(
    public platform: Platform
    ) {
    }

  ngOnInit(): void {
  }
}
